module.exports = __webpack_public_path__ + "static/media/greece-flowers-bg.ab665987.png";